import React from "react";
import { ASSESSMENT_TYPES } from "../../constants/assessmentTypes";
import { IconSearch } from "../shared/Icons";

const FILTER_TABS = ["All", "Draft", "Submitted", "Feedback", "Reviewed"];

/**
 * Search box + status filter tabs + type dropdown.
 */
const FilterBar = ({
  searchQuery,
  onSearchChange,
  activeFilter,
  onFilterChange,
  counts,
  typeFilter,
  onTypeChange,
}) => (
  <div
    style={{
      background: "white",
      borderRadius: "12px",
      padding: "14px 18px",
      boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
      marginBottom: "14px",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        flexWrap: "wrap",
      }}
    >
      {/* Search */}
      <div style={{ position: "relative", flex: "1", minWidth: "180px" }}>
        <div
          style={{
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <IconSearch />
        </div>
        <input
          placeholder="Search tool name..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{
            width: "100%",
            padding: "8px 8px 8px 32px",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            fontSize: "13px",
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>

      {/* Status tabs */}
      {FILTER_TABS.map((f) => (
        <button
          key={f}
          onClick={() => onFilterChange(f)}
          style={{
            background: activeFilter === f ? "#bb1ccc" : "#f3f4f6",
            color: activeFilter === f ? "white" : "#555",
            border: "none",
            borderRadius: "8px",
            padding: "8px 16px",
            fontWeight: "600",
            fontSize: "13px",
            cursor: "pointer",
            transition: "background 0.15s",
          }}
        >
          {f} ({counts[f] ?? 0})
        </button>
      ))}

      {/* Type dropdown */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
        <span style={{ fontSize: "13px", color: "#555" }}>Type:</span>
        <select
          value={typeFilter}
          onChange={(e) => onTypeChange(e.target.value)}
          style={{
            padding: "8px 12px",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            fontSize: "13px",
            outline: "none",
          }}
        >
          <option value="">Select type(s)</option>
         {ASSESSMENT_TYPES.map((t) => (
  <option key={t.value} value={t.value}>{t.label}</option>
))}
        </select>
      </div>
    </div>
  </div>
);

export default FilterBar;
